module.exports = __webpack_public_path__ + "img/5.5ae53e3.png";